import { render, staticRenderFns } from "./features.vue?vue&type=template&id=2756a27c&scoped=true&lang=pug&"
import script from "./features.vue?vue&type=script&lang=js&"
export * from "./features.vue?vue&type=script&lang=js&"
import style0 from "./features.vue?vue&type=style&index=0&id=2756a27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2756a27c",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/prepayCards?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231207155841%2Fcomponents%2Fproducts%2Fprepay-cards%2Ffeatures.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/widgets/list-item.vue').default,ProductsCardsBrand: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/products/cards/brand.vue').default})
